import { SpanStatusCode, trace, Tracer } from "@opentelemetry/api";
import { Chart, StudyTemplates } from "../models/charts";

var tracer: Tracer;

function initTracer() {
    tracer = trace.getTracer("vortex-tracer");
}
export class SaveLoad {
    private _charts: Chart[] = [];
    private _studyTemplates: StudyTemplates[] = [];
    private _drawingTemplates: StudyTemplates[] = [];
    private _inHouseUrl: string;
    private _auth_token: string;
    private _getStudyTemplates: Promise<StudyTemplates[]>;
    private _getDrawingTemplates: Promise<StudyTemplates[]>;
    constructor(inHouseUrl: string, auth_token: string) {
        this.init();
        tracer = tracer;
        this._charts = [];
        this._studyTemplates = [];
        this._drawingTemplates = [];
        this._inHouseUrl = inHouseUrl + "aux/";
        this._auth_token = auth_token;
        this._getStudyTemplates = this._getAllStudyTemplates();
        this._getDrawingTemplates = this._getAllDrawingTemplates();
    }

    init() {
        initTracer()
    }

    getAllCharts(): Promise<Chart[]> {
        return tracer.startActiveSpan("GetAllCharts", async (span) => {
            return this._getAllCharts().then((_) => {
                return Promise.resolve(this._charts);
            }).catch((error) => {
                span.setStatus({ code: SpanStatusCode.ERROR });
                return Promise.reject(error)
            }).finally(() => {
                span.end()
            })
        })

    }

    _getAllCharts() {
        return this._inhouseRequest('chartsList').then((response: Chart[]) => {
            this._charts = (response || [])
            return Promise.resolve()
        })
    }

    removeChart(id: number): Promise<void> {
        return tracer.startActiveSpan("RemoveChart", async (span) => {
            for (var i = 0; i < this._charts.length; ++i) {
                if (this._charts[i].id.toString() === id.toString()) {

                    return this._inhouseRequest('charts/' + id.toString(), undefined, undefined, "DELETE").then((_) => {
                        this._charts.splice(i, 1);
                        return Promise.resolve()
                    }).catch((err) => { return Promise.reject(err) })
                        .finally(() => {
                            span.end()
                        })
                }
            }
            span.end()
            return Promise.reject();
        })

    }

    saveChart(chartData: Chart): Promise<string> {
        chartData.timestamp = new Date().valueOf();
        return tracer.startActiveSpan("SaveChart", async (span) => {
            return this._inhouseRequest('charts', chartData, undefined, "POST").then((response: Chart) => {
                var index: number = this._charts.findIndex((t: Chart) => t.id == chartData.id)
                if (index == -1) {
                    window.GtmPusher({
                        event: 'tv-chart-layout-created'
                    })
                    this._charts.push(response);
                } else {
                    this._charts[index] = response
                }

                return Promise.resolve(response.id.toString());
            }).catch((error) => { console.log(error); span.setStatus({ code: SpanStatusCode.ERROR }); return Promise.reject(error) })
                .finally(() => {
                    span.end()
                })
        })

    }

    getChartContent(id: number): Promise<string> {
        return tracer.startActiveSpan("GetChartContent", async (span) => {
            return this._inhouseRequest('charts/' + id.toString(), undefined, undefined, "GET").then((response: Chart) => {
                return Promise.resolve(response.content);
            }).catch((error) => { console.log(error); span.setStatus({ code: SpanStatusCode.ERROR }); return Promise.reject(error) })
                .finally(() => {
                    span.end()
                })
        })
    }

    removeStudyTemplate(studyTemplateInfo: StudyTemplates): Promise<void> {
        console.error("remove study template", studyTemplateInfo)
        var id = studyTemplateInfo.name?.split("|")[0]
        for (var i = 0; i < this._studyTemplates.length; ++i) {
            if (this._studyTemplates[i].id?.toString() === id?.toString()) {
                return tracer.startActiveSpan("RemoveStudyTemplate", async (span) => {
                    return this._inhouseRequest('studyTemplates/' + id?.toString(), undefined, undefined, "DELETE").then((_) => {
                        this._studyTemplates.splice(i, 1);
                        return Promise.resolve()
                    }).catch((err) => { return Promise.reject(err) })
                        .finally(() => {
                            span.end()
                        })
                })
            }
        }

        return Promise.reject();
    }

    getStudyTemplateContent(studyTemplateData: StudyTemplates): Promise<string> {
        for (var i = 0; i < this._studyTemplates.length; ++i) {
            if (this._studyTemplates[i].name === studyTemplateData.name) {
                if (this._studyTemplates[i] !== undefined) {
                    return Promise.resolve(this._studyTemplates[i].content);
                } else {
                    return Promise.reject();
                }

            }
        }

        return Promise.reject();
    }

    saveStudyTemplate(studyTemplateData: StudyTemplates): Promise<void> {
        console.error("study template", studyTemplateData)

        studyTemplateData.timestamp = new Date().valueOf();
        var aa = JSON.stringify(studyTemplateData.meta_info)
        studyTemplateData.meta_info = aa
        return tracer.startActiveSpan("async ", async (span) => {
            return this._inhouseRequest('studyTemplates', studyTemplateData, undefined, "POST").then((response: StudyTemplates) => {
                response.name = response.id?.toString() + "|" + response.name
                var index: number = this._studyTemplates.findIndex((t: StudyTemplates) => t.id == studyTemplateData.id)
                if (index == -1) {
                    this._studyTemplates.push(response);
                } else {
                    this._studyTemplates[index] = response
                }
                return Promise.resolve();
            }).catch((error) => { console.log(error); span.setStatus({ code: SpanStatusCode.ERROR }); return Promise.reject(error) })
                .finally(() => {
                    span.end()
                })
        })
    }

    getAllStudyTemplates(): Promise<StudyTemplates[]> {
        return this._getStudyTemplates.then((_) => {
            return Promise.resolve(this._studyTemplates);
        })

    }

    _getAllStudyTemplates() {
        return tracer.startActiveSpan("GetAllStudyTemplates", async (span) => {
            return this._inhouseRequest('studyTemplates').then((response: StudyTemplates[]) => {
                this._studyTemplates = (response.map((aa: StudyTemplates) => {
                    aa.name = aa.id?.toString() + "|" + aa.name
                    aa.meta_info = JSON.parse(aa.meta_info as string)
                    return aa
                }) || [])
                return Promise.resolve(this._studyTemplates)
            }).catch((error) => { console.log(error); span.setStatus({ code: SpanStatusCode.ERROR }); return Promise.reject(error) })
                .finally(() => {
                    span.end()
                })
        })

    }

    _getAllDrawingTemplates() {
        return tracer.startActiveSpan("GetAllDrawingTemplates", async (span) => {
            return this._inhouseRequest('drawingTemplates').then((response: StudyTemplates[]) => {
                this._drawingTemplates = (response.map((aa: StudyTemplates) => {
                    aa.name = aa.name
                    aa.content = aa.content
                    return aa
                }) || [])
                return Promise.resolve(this._drawingTemplates)
            }).catch((error) => { console.log(error); span.setStatus({ code: SpanStatusCode.ERROR }); return Promise.reject(error) })
                .finally(() => {
                    span.end()
                })
        })
    }
    removeDrawingTemplate(templateName: string): Promise<void> {
        for (var i = 0; i < this._drawingTemplates.length; ++i) {
            if (this._drawingTemplates[i].name === templateName) {
                return tracer.startActiveSpan("RemoveDrawingTemplate", async (span) => {
                    return this._inhouseRequest(`drawingTemplates/${this._drawingTemplates[i].id}`, undefined, undefined, "DELETE").then((_) => {
                        this._drawingTemplates.splice(i, 1);
                        return Promise.resolve();
                    }).catch((err) => { return Promise.reject(err) })
                        .finally(() => {
                            span.end()
                        })
                })
            }
        }

        return Promise.reject();
    }

    loadDrawingTemplate(templateName: string): Promise<string> {
        for (var i = 0; i < this._drawingTemplates.length; ++i) {
            if (this._drawingTemplates[i].name === templateName) {
                return Promise.resolve(this._drawingTemplates[i].content);
            }
        }

        return Promise.reject();
    }

    saveDrawingTemplate(templateName: string, content: string): Promise<void> {
        // studyTemplateData.meta_info = JSON.stringify(studyTemplateData.meta_info)
        var payload: StudyTemplates = {
            name: templateName,
            content: content,
            id: 0
        }
        for (var i = 0; i < this._drawingTemplates.length; ++i) {
            if (this._drawingTemplates[i].name === templateName) {
                payload.id = this._drawingTemplates[i].id
                break;
            }
        }
        return tracer.startActiveSpan("SaveDrawingTemplate", async (span) => {
            return this._inhouseRequest('drawingTemplates', payload, undefined, "POST").then((response) => {
                response.name = payload.name
                response.id = response.drawing_template_id
                for (var i = 0; i < this._drawingTemplates.length; ++i) {
                    if (this._drawingTemplates[i].name === templateName) {
                        this._drawingTemplates.splice(i, 1);
                        break;
                    }
                }
                this._drawingTemplates.push(response);
                return Promise.resolve();
            }).catch((error) => { console.log(error); span.setStatus({ code: SpanStatusCode.ERROR }); return Promise.reject(error) })
                .finally(() => {
                    span.end()
                })
        })

    }

    getDrawingTemplates(): Promise<string[]> {
        return this._getDrawingTemplates.then((_) => {
            return Promise.resolve(this._drawingTemplates.map(function (template: StudyTemplates) {
                return template.name;
            }));
        })
    }
    private async _inhouseRequest(urlPath: string, body?: StudyTemplates, params?: Record<string, string>, method: string = "GET") {
        const headers = new Headers({
            "Authorization": `Bearer ${this._auth_token}`,
        });

        const options: RequestInit = {
            headers,
            method,
        };

        if (body !== undefined && method !== "GET") {
            options.body = JSON.stringify(body);
        }

        const url = new URL(`${this._inHouseUrl}${urlPath}`);
        if (params) {
            url.search = new URLSearchParams(params).toString();
        }

        const response = await fetch(url.toString(), options);
        const responseText = await response.text();
        return JSON.parse(responseText);
    }

}